<template>
  <div>
    <div class="flex_between search">
      <div class="left flex1">
        <el-form :model="form" label-suffix=":">
          <div class="form-box">
            <el-form-item label="支付时间" class="formItem">
              <el-date-picker
                v-model="form.time"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                :clearable="false"
                end-placeholder="结束日期"
                :editable="false"
                :value-format="'yyyy-MM-dd'"
                unlink-panels
                :picker-options="pickerOptions"
              />
            </el-form-item>
            <div>
              <el-button type="primary" @click="query">查询</el-button>
              <el-button @click="resetForm">重置</el-button>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="total_box flex mb22 center" style="flex-wrap: wrap;">
      <div class="mr20 total_item">商户号支付总金额：<div class="active_color mt5">￥{{ $formatCurrency(summary_money) || '0.00' }}</div></div>
      <div v-for="(item, index) in mch_sum_money" :key="index" class="mr20 total_item">{{ item.mch_id }}累计支付：<div class="active_color mt5">￥{{ $formatCurrency(item.sum_money) || '0.00' }}</div></div>
      <div class="mr20 total_item">累计服务费：<div class="active_color mt5">￥{{ $formatCurrency(service_fee) || '0.00' }}</div></div>
      <div class="mr20 total_item">合计总金额：<div class="active_color mt5">￥{{ $formatCurrency(total_money_service_fee) || '0.00' }}</div></div>
    </div>
    <!-- <div>
      <div v-if="list.length" class="custom-table mt15">
        <div class="head">
          <div class="item-data"><div class="ellipsis">商户号</div></div>
          <div v-for="(item, key) in list[0].item" :key="key" class="item-data"><div class="ellipsis">{{ key }}</div></div>
        </div>
        <div class="table-data">
          <div v-for="(ls, index) in list" :key="ls.company_id" class="vertical-item">
            <div class="item-data">
              <div class="ellipsis" @mouseenter="showTooltip($event, index, 'item-data1')">
                <el-tooltip effect="dark" :disabled="flagTooltip" :content="ls.mch_id" placement="top-start">
                  <span :ref="`item-data1${index}`">{{ ls.mch_id }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-for="(ob, key, ind) in ls.item" :key="key" class="item-data">
              <div class="ellipsis" @mouseenter="showTooltip($event, ind, 'item-data2')">
                <el-tooltip effect="dark" :disabled="flagTooltip" :content="`${ob}`" placement="top-start">
                  <span :ref="`item-data2${ind}`">￥{{ $formatCurrency(ob) }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <noData v-else />
    </div> -->
    <div class="mt20">
      <div v-if="mch_list.length" class="custom-table-new">
        <div class="custom-head flex">
          <div class="th" style="width:130px;">日期|商户号</div>
          <div v-for="(mch, index) in mch_list" :key="index" class="th flex1">
            <div class="ellipsis" @mouseenter="showTooltip($event, index, 'mch-name')">
              <el-tooltip effect="dark" :disabled="flagTooltip" :content="mch" placement="top-start">
                <span :ref="`mch-name${index}`">{{ mch }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div class="custom-body">
          <div v-for="(value, key) in mch_value_list" :key="key" class="tr flex">
            <div class="td" style="width:130px;">{{ key }}</div>
            <div v-for="(val, i) in value" :key="i" class="td flex1">
              <div class="ellipsis" @mouseenter="showTooltip($event, i, 'mch-money')">
                <el-tooltip effect="dark" :disabled="flagTooltip" :content="`${val}`" placement="top-start">
                  <span :ref="`mch-money${i}`">￥{{ $formatCurrency(val) }}</span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <noData v-else />
    </div>
  </div>
</template>

<script>
import column from '../columns/payCheck'
import dayjs from 'dayjs'
import noData from '@/components/noData'
import mixin from '../mixins'
import { payCheck } from '@/api/pay'
export default {
  name: 'List',
  components: {
    noData
  },
  mixins: [mixin],
  data() {
    return {
      column,
      minDate: '', // 开始时间
      form: {
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      },
      list: [],
      summary_money: '',
      service_fee: '',
      total_money_service_fee: '',
      mch_sum_money: [],
      mch_list: [],
      mch_value_list: []
      // 禁止跨月，禁止夸年
      // selfPicker: {
      //   onPick: ({ maxDate, minDate }) => {
      //     if (minDate && !maxDate) {
      //       this.minDate = minDate
      //     } else {
      //       this.minDate = ''
      //     }
      //     this.maxDate = maxDate
      //   },
      //   disabledDate: time => {
      //     if (this.minDate) {
      //       return this.minDate.getFullYear() !== time.getFullYear() || this.minDate.getMonth() !== time.getMonth()
      //     }
      //     return false
      //   }
      // }
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    async query() {
      const res = await payCheck({ start_day: this.form.time[0], end_day: this.form.time[1] })
      if (res.code === 200) {
        this.list = res.data.mch_list
        this.mch_list = res.data.mch_list.map(item => item.mch_id)
        // 解析数据结构
        const parse_map = {}
        // 获取所有日期
        const keys = Object.keys(res.data.mch_list[0].item)
        for (let i = 0; i < keys.length; i++) {
          const ele = keys[i]
          parse_map[ele] = []
          res.data.mch_list.forEach(list => {
            for (const key in list.item) {
              if (ele === key) {
                parse_map[ele].push(list.item[key])
              }
            }
          })
        }
        this.mch_value_list = parse_map
        this.summary_money = res.data.summary_money
        this.service_fee = res.data.service_fee
        this.total_money_service_fee = res.data.total_money_service_fee
        this.mch_sum_money = res.data.mch_sum_money
      }
    },
    resetForm() {
      this.form = {
        time: [dayjs(new Date(new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + '01')).format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
      }
      this.query()
    }
  }
}
</script>

<style lang="scss" scoped>
.mt15{
  margin-top: 15px;
}
.custom-table{
  max-width: 100%;
  position: relative;
  .vertical-item{
    display: inline-block;
  }
  .item-data{
      padding: 8px 10px;
      // height: 50px;
      border-left: 1px solid #EBEEF5;
      border-top: 1px solid #EBEEF5;
      .ellipsis{
        width: 100%;
        line-height: 30px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        text-align: center;
      }
    }
  .head{
    position: absolute;
    background: #F5F8FA;
    display: inline-block;
    font-weight: bold;
    .item-data{
      min-width: 130px;
    }
  }
  .table-data{
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-left: 130px;
    box-sizing: border-box;
    border-bottom: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    display: flex;
    .vertical-item{
      min-width: 150px;
      flex: 1;
    }
  }
}
.custom-table-new{
  text-align: center;
  border-right: 1px solid #EBEEF5;
  border-bottom: 1px solid #EBEEF5;
  .th,.td{
    padding: 8px 10px;
    border-left: 1px solid #EBEEF5;
    border-top: 1px solid #EBEEF5;
    line-height: 26px;
    .ellipsis{
      width: 100%;
      line-height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .custom-head{
    background: #F5F8FA;
    font-weight: bold;
  }
  .custom-body{
    max-height: 450px;
    overflow-y: auto;
  }
}
.total_box{
  .total_item{
    margin: 10px 0px;
    padding: 0px 10px;
    border-right: 1px solid #e1e6eb;
    min-width: 225px;
    &:last-child{
      border-right: 1px solid transparent;
    }
  }
}
</style>
